import React from 'react';
import { Tooltip } from 'antd';
import { subtract } from 'lodash';
import { METRIC_NEWAPP_VERSION } from '@utils/constants';
import SpiUpIco from '@icons/aiAlerts/spi-up.svg';
import SpiDownIco from '@icons/aiAlerts/spi-down.svg';
import {
  RowWrapper,
  LeftDiv,
  CauseText,
  SubText,
  CauseWrap,
  SubSpiText,
  DimensionName,
  DimensionApp,
  SpiDiff,
} from './styled';
import StreamList from './StreamList';
import { formatDate } from './formatter';

function Row({ data, openSummary }) {
  const { newVersion, oldVersion } = data;
  const deviceName = METRIC_NEWAPP_VERSION;
  const handleClick = () => {
    openSummary(data);
  };

  const getDiff = (newVersion: any, oldVersion: any) => {
    const diffValue = subtract(newVersion, oldVersion);
    if (diffValue < 0) {
      return <SpiDownIco />;
    }
    if (diffValue > 0) {
      return <SpiUpIco />;
    }
    return false;
  };

  return (
    <RowWrapper>
      <LeftDiv>
        <CauseWrap onClick={handleClick}>
          <CauseText>
            <Tooltip
              placement="bottomLeft"
              title={`${newVersion.dimensions[deviceName]} ${'\xa0'} ${Object.values(newVersion.dimensions)[1]} ${'\xa0'} ${formatDate(newVersion.releaseDate)}`}
            >
              <DimensionName>{newVersion.dimensions[deviceName]}</DimensionName>
              <DimensionApp>{`${Object.values(newVersion.dimensions)[1]}`}</DimensionApp>
            </Tooltip>
          </CauseText>
          <SubSpiText>
            <StreamList data={newVersion.metrics} type={'newVersion'} />
          </SubSpiText>
          <SpiDiff>
            {getDiff(
              newVersion.metrics.StreamingPerformanceIndex,
              oldVersion.metrics.StreamingPerformanceIndex,
            )}
          </SpiDiff>
        </CauseWrap>
        <SubText>
          <CauseText>
            <Tooltip
              placement="bottomLeft"
              title={`${oldVersion.dimensions[deviceName]} ${'\xa0'} ${Object.values(oldVersion.dimensions)[1] ? Object.values(oldVersion.dimensions)[1] : ''}`}
            >
              <DimensionName>{oldVersion.dimensions[deviceName]}</DimensionName>
              <DimensionApp>{`${Object.values(oldVersion.dimensions)[1] ? Object.values(oldVersion.dimensions)[1] : ''}`}</DimensionApp>
            </Tooltip>
          </CauseText>
          <SubSpiText>
            <StreamList data={oldVersion.metrics} type={'oldVersion'} />
          </SubSpiText>
        </SubText>
      </LeftDiv>
    </RowWrapper>
  );
}

export default Row;
